import Section from '../ui/Section'
import { Display, Statement, Body, Points, Accent } from '../ui/Type'

const USUAL = ['FLOPs.', 'GPU count.', 'Tokens per second.', 'Model size.']

const MEASURES = ['Work completed', 'Quality', 'Throughput', 'Latency', 'Concurrency', 'Infrastructure cost']

const TECHNICAL = ['Utilization', 'Memory efficiency', 'Network efficiency', 'Energy efficiency']

export default function IntelligenceProductivity() {
  return (
    <Section label="Intelligence productivity" tone="tint">
      <Display>
        More useful intelligence from <Accent>finite infrastructure.</Accent>
      </Display>
      <Body className="mt-8">The amount of useful AI work produced from finite physical infrastructure.</Body>

      <Body className="mt-14">The AI infrastructure race is usually measured in:</Body>
      <p className="mt-5 text-[1.05rem] leading-[1.8] text-[var(--muted)]">{USUAL.join(' ')}</p>

      <Body className="mt-14">LiquidBrain asks a different question:</Body>
      <Statement className="mt-6">How much useful AI work can this infrastructure actually accomplish?</Statement>

      <Body className="mt-14">Measure across:</Body>
      <Points className="mt-8" cols={2} items={MEASURES} />

      <div className="mt-10 border-t border-[var(--line)] pt-6">
        <div className="font-mono text-[11.5px] tracking-[0.14em] text-[var(--faint)] uppercase">Supporting metrics</div>
        <p className="mt-3 font-mono text-[12.5px] leading-[2] tracking-[0.04em] text-[var(--ink-2)]">
          {TECHNICAL.join('\u00a0· ')}
        </p>
      </div>

      <Body className="mt-14">
        More intelligence productivity means more useful AI work from the same physical resources.
      </Body>
    </Section>
  )
}
